import Sprite from "./Sprite";
import SpriteAnimationManager from "./SpriteAnimationManager";
import Spritesheet from "./Spritesheet";

export default class DawnLikeSprite extends Sprite {
    /**
     * @param {SpriteAnimationManager} spriteAnimationManager
     * @param {Spritesheet} spritesheet0
     * @param {Spritesheet} spritesheet1
     * @param {number} spriteX
     * @param {number} spriteY
     */
    constructor(spriteAnimationManager, spritesheet0, spritesheet1, spriteX, spriteY) {
        super(spriteX, spriteY);

        /**
         * @constant
         * @type {SpriteAnimationManager}
         */
        this.spriteAnimationManager = spriteAnimationManager;

        /**
         * @constant
         * @type {Spritesheet}
         */
        this.spritesheet0 = spritesheet0;
        /**
         * @constant
         * @type {Spritesheet}
         */
        this.spritesheet1 = spritesheet1;

    }

    /**
     * @override
     * @returns {Image}
     */
    getImage() {
        const frameIndex = this.spriteAnimationManager.getDefaultFrameIndex(2);
        if (frameIndex == 0) {
            return this.spritesheet0.image;
        }
        else {
            return this.spritesheet1.image
        }
    }
    
    /**
     * @override
     * @returns {number}
     */
    getSize() {
        return this.spritesheet0.spriteSize;
    }
}